import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { useBranchStore } from 'shared/store/branchesSlice'

export const Website = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()
  const [website, setWebsite] = useState<string>('')

  useEffect(() => {
    if (branchId && branchList?.length) {
      setWebsite(branchList?.find(branch => branch.Intern === branchId)?.Website || '')
    }
  }, [branchList?.length, branchId])

  const updateWebsite = () => {
    if (branchList?.find(branch => branch.Intern === branchId)?.Website !== website) {
      updateBranch({ Website: website })
    }
  }

  return <Input label='Website' onChange={setWebsite} onBlur={updateWebsite} value={website} />
}
